module.exports = __webpack_public_path__ + "img/upload@2x.05be64ef.png";